import React, {useState, useEffect, useContext} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {CSSTransition} from 'react-transition-group';
import './dashboardselectorbottom.css';
import DashboardSelectorRow from "../components/DashboardSelectorRow";

export default function DashboardSelectorBottom({title}){
	
	const [displayDropDown, setDisplayDropDown] = useState(false);
	
	useEffect(() => {
		setDisplayDropDown(false);
	}, [title]);
	
	const thisContainer = {
		display:"flex",
		position:"fixed",
		bottom:"10px",
		left:"calc(50% - 40px)",
		zIndex:"20000",
		flexDirection:"column"
	};
	
	const primaryContainer = {
		display:"flex",
		width:"500px",
		height:"40px",
		backgroundColor:COLOR_GRAY_BANNER_BACKGROUND,
		borderRadius:"20px",
		alignItems:"center",
		boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
		justifyContent:"space-between",
		zIndex:"2"
	};
	
	const primaryLabel = {
		display:"flex",
		paddingLeft:"20px",
		fontSize:"16px",
		color:"white"
	};
	
	const primaryRight = {
		display:"flex",
		alignItems:"center"
	};
	
	const switchText = {
		display:"flex",
		fontSize:"12px",
		color:"white",
		marginRight:"10px"
	};
	
	const iconStyle = {
		marginRight:"10px",
		color:"orange",
		width:"20px",
		height:"20px",
		cursor:"pointer"
	};
	
	const clickFunction = () => {
		setDisplayDropDown(!displayDropDown)
	};
	
	const dashboardChoices = [
		{label:"Availability/Breakdown", icon:"users", isLive:true, url:""},
		{label:"Replacement Cist & Lifecycle", icon:"city", isLive:true, url:"spaceall"},
		{label:"Energy", icon:"lightbulb", isLive:true, url:""},
		{label:"Compliance", icon:"check", isLive:true, url:""},
		{label:"Operations & Services", icon:"cogs", isLive:true, url:""},
		{label:"Assets & Condition", icon:"laptop", isLive:true, url:""}
	];
	
	const dashboardChoiceDisplay = dashboardChoices.map((item, index) =>
		<DashboardSelectorRow
			icon={item.icon}
			title={item.label}
			isLive={item.isLive}
			url={item.url}
			collapseFunction={clickFunction}
		/>
	);
	
	return (
		<div style={thisContainer}>
				<CSSTransition
				    in={displayDropDown}
				    classNames="dashboardselectorbottom"
				    timeout={1000}
				    appear={true}
			>
				<div className="dashboardselectorbottom">
					{dashboardChoiceDisplay}
				</div>
			</CSSTransition>
			<div style={primaryContainer}>
				<div style={primaryLabel}>
					{title}
				</div>
				<div style={primaryRight}>
					<div style={switchText}>
						SWITCH
					</div>
					<FontAwesomeIcon icon="sync" style={iconStyle} onClick={clickFunction}/>
				</div>
			</div>
		
		</div>
	);
}